module.exports = __webpack_public_path__ + "static/media/service_laptop.b2f8f8cf.png";